import { ChevronRight } from "lucide-react";

// Same fixed label the desktop top bar shows (there is no plant switcher).
export const PLANT_NAME = "Canares Automation — Line A";

export function ModuleRow({ module: n, onClick, sub }) {
  return (
    <button type="button" onClick={onClick}
      className="w-full min-h-[52px] flex items-center gap-3 px-3 py-2 text-left bg-[var(--m-card)] active:bg-[var(--m-skeleton)]"
      data-testid={`mobile-row-${n.tid || n.to}`}>
      <span className="shrink-0 w-9 h-9 rounded-md flex items-center justify-center bg-[#4fc3f7]/15 text-[var(--m-accent-strong)]">
        {n.icon ? <n.icon className="w-[18px] h-[18px]" strokeWidth={2} /> : <ChevronRight className="w-4 h-4" />}
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-[15px] font-medium leading-snug">{n.label}</span>
        {sub && <span className="block text-[12px] text-[var(--m-muted)] truncate">{sub}</span>}
      </span>
      <ChevronRight className="shrink-0 w-4 h-4 text-[var(--m-muted)]" />
    </button>
  );
}
